/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiPetAllergy,
  ApiPetAllergyFromJSON,
  ApiPetAllergyFromJSONTyped,
  ApiPetAllergyToJSON,
} from './ApiPetAllergy';
import {
  ApiPetBreed,
  ApiPetBreedFromJSON,
  ApiPetBreedFromJSONTyped,
  ApiPetBreedToJSON,
} from './ApiPetBreed';
import {
  ApiPetMedicalCondition,
  ApiPetMedicalConditionFromJSON,
  ApiPetMedicalConditionFromJSONTyped,
  ApiPetMedicalConditionToJSON,
} from './ApiPetMedicalCondition';
import {
  ApiPetMedication,
  ApiPetMedicationFromJSON,
  ApiPetMedicationFromJSONTyped,
  ApiPetMedicationToJSON,
} from './ApiPetMedication';
import {
  ApiPetMedicationAllergy,
  ApiPetMedicationAllergyFromJSON,
  ApiPetMedicationAllergyFromJSONTyped,
  ApiPetMedicationAllergyToJSON,
} from './ApiPetMedicationAllergy';
import {
  ApiPetType,
  ApiPetTypeFromJSON,
  ApiPetTypeFromJSONTyped,
  ApiPetTypeToJSON,
} from './ApiPetType';

/**
 *
 * @export
 * @interface ApiPetAttributeData
 */
export interface ApiPetAttributeData {
  /**
   *
   * @type {Array<ApiPetType>}
   * @memberof ApiPetAttributeData
   */
  types: Array<ApiPetType>;
  /**
   *
   * @type {Array<ApiPetBreed>}
   * @memberof ApiPetAttributeData
   */
  breeds: Array<ApiPetBreed>;
  /**
   *
   * @type {Array<ApiPetAllergy>}
   * @memberof ApiPetAttributeData
   */
  allergies: Array<ApiPetAllergy>;
  /**
   *
   * @type {Array<ApiPetMedication>}
   * @memberof ApiPetAttributeData
   */
  medications: Array<ApiPetMedication>;
  /**
   *
   * @type {Array<ApiPetMedicationAllergy>}
   * @memberof ApiPetAttributeData
   */
  medicationAllergies: Array<ApiPetMedicationAllergy>;
  /**
   *
   * @type {Array<ApiPetMedicalCondition>}
   * @memberof ApiPetAttributeData
   */
  medicalConditions: Array<ApiPetMedicalCondition>;
}

export function ApiPetAttributeDataFromJSON(json: any): ApiPetAttributeData {
  return ApiPetAttributeDataFromJSONTyped(json, false);
}

export function ApiPetAttributeDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPetAttributeData {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    types: (json['types'] as Array<any>).map(ApiPetTypeFromJSON),
    breeds: (json['breeds'] as Array<any>).map(ApiPetBreedFromJSON),
    allergies: (json['allergies'] as Array<any>).map(ApiPetAllergyFromJSON),
    medications: (json['medications'] as Array<any>).map(ApiPetMedicationFromJSON),
    medicationAllergies: (json['medicationAllergies'] as Array<any>).map(
      ApiPetMedicationAllergyFromJSON,
    ),
    medicalConditions: (json['medicalConditions'] as Array<any>).map(
      ApiPetMedicalConditionFromJSON,
    ),
  };
}

export function ApiPetAttributeDataToJSON(value?: ApiPetAttributeData | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    types: (value.types as Array<any>).map(ApiPetTypeToJSON),
    breeds: (value.breeds as Array<any>).map(ApiPetBreedToJSON),
    allergies: (value.allergies as Array<any>).map(ApiPetAllergyToJSON),
    medications: (value.medications as Array<any>).map(ApiPetMedicationToJSON),
    medicationAllergies: (value.medicationAllergies as Array<any>).map(
      ApiPetMedicationAllergyToJSON,
    ),
    medicalConditions: (value.medicalConditions as Array<any>).map(ApiPetMedicalConditionToJSON),
  };
}
